<template>

  <!-- footer_area -->
  <footer id="footer" class="footerArea">

    <div class="inner">
      <ul class="bi">
        <li class="img"><img src="/statics/img/bi.png"></li>
        <li><p>BLUFF &amp; CATCH</p></li>
        <li class="copy">©{{currentYear}} Bluff&amp;Catch All Rights Reserved.</li>
        <!--<li class="copy">BlankHill Entertainment Inc.<br>©2026 Bluff&amp;Catch All Rights Reserved.</li>-->
        <!--<li class="lang">
          <a href="javascript:" @click="gotoSite('EN')" title="ENGLISH"><img src="/statics/img/footer_eng.png"></a>
          <a href="javascript:" @click="gotoSite('KR')" title="KOREAN"><img src="/statics/img/footer_kor.png"></a>
          <a href="javascript:" @click="toggleFaqDialog(true);" title="FAQ"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37073/tips_1727348979696.png"></a>
          <a href="javascript:" @click="gotoSite('JP')" title="JAPANESE"><img src="/statics/img/footer_jpn.png"></a>
          <a href="javascript:" @click="toggleTeamDialog(true);" title="TEAM"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37072/tips_1727348873594.png"></a>
          <span class="empty" title="TBD"></span>
        </li>-->
      </ul>
      <ul class="company">
        <li class="about"><p>ABOUT US</p>Bluff&amp;Catch is a specialized content media for poker in the Asia-Pacific market. We provide coverage of major poker tournaments and industry news.</li>
        <li class="about">South Korea | Japan | Vietnam | Thailand | Taiwan | Singapore | Philippines | Malaysia | India | China | Cambodia | Australia</li>
        <li>
          <!--<a @click="toggleFooter1Dialog(true);">Terms of Use</a>
          <a @click="toggleFooter2Dialog(true);">콘텐츠보호안내</a>-->
          <a @click="toggleFooter3Dialog(true);">Cookie Policy</a>
        </li>
        <li class="channel_ctnr">
          <p>OFFICIAL CHANNEL</p>
          <a class="channel" href="https://www.instagram.com/bluffandcatch/" target="_blank"><img src="/statics/img/ftr_insta.png" title="instagram"></a>
          <a class="channel" href="https://t.me/bluffcatch_kr" target="_blank"><img src="/statics/img/ftr_tele.png" title="telegram"></a>
          <a class="channel" href="https://www.facebook.com/BluffCatch/" target="_blank"><img src="/statics/img/ftr_fb.png" title="facebook"></a>
        </li>
      </ul>
      <ul class="etc">
        <li><p>CAREER</p>We’re always looking for members to join our team.<br>Wanted: Content Marketer, Web Designer, Guest Journalist<br>Apply : allin@bluffcatch.com</li>
        <li><p>CONTACT US</p>News reports, affiliate/promotion/advertising and other inquiries.<br>E-MAIL : allin@bluffcatch.com<br>Telegram : @bluffcatch</li>
      </ul>
    </div>

    <!-- Faq -->
    <q-dialog v-model="isOpenFaqDialog">
			<div class="modal_faq">
		    <a class="modal_close_btn" @click="toggleFaqDialog(false);">close</a>
		    <h5>FAQ</h5>
		    <div class="contain">
          <ul class="qna">
            <li class="que">사이트 언어를 변경하고 싶어요.</li>
            <li class="ans">사이트 우측상단 메뉴(☰) 버튼 클릭 -> 좌측상단 언어 변경으로 각 언어별 사이트 이동이 가능합니다. (PC 접속의 경우 우측 상단 및 최하단에 위치)<br>Bluff&amp;Catch는 영문, 한국어, 일본어 3개 언어의 사이트를 운영중입니다. 접속 국가의 IP에 따라 맞춤 언어로 자동 접속되지만 간혹 쿠키오류가 발생할 수 있으니, 지속적인 오류 발생 시 브라우저 쿠키삭제 및 재접속을 권장합니다.</li>
            <li class="que">왜 3개 언어 사이트 내용, 구성이 조금씩 다른가요?</li>
            <li class="ans">Bluff&amp;Catch는 아시아퍼시픽 사용자들에게 맞춰 3개 언어의 사이트를 개별적으로 운영하고 있습니다. 같은 기사라도 내용이 조금 다를 수 있으며, 각 언어별 사이트 사용자를 위한 맞춤형 기사 및 콘텐츠가 구성될 수 있습니다.</li>
            <li class="que">Bluff&amp;Catch는 특정 브랜드 대회사 소속인가요? 온라인 게임사인가요?</li>
            <li class="ans">아니요. Bluff&amp;Catch는 특정 대회사/게임사와 관계없는 <b>독립적인 미디어</b> 입니다. 각 브랜드들과는 다양한 형태의 제휴 파트너십을 통해 기사 콘텐츠 제작, 배너광고, 현장취재 등을 진행하고 있습니다.</li>
            <li class="que">Bluff&amp;Catch와는 어떤 형태의 제휴가 가능한가요?</li>
            <li class="ans">형태에 상관없이 어떤 방향의 제휴라도 협의가 가능합니다. 현장취재 및 기사제작 뿐만 아니라 맞춤형 라이브리포팅, 갤러리(촬영 제휴)등 형태도 있으며, 파트너사의 니즈에 맞게 제안 구성도 가능합니다. 문의는 이메일(allin@bluffcatch.com / lime@bluffcatch.com)로 부탁드립니다.</li>
          </ul>
        </div>
		  </div>
		</q-dialog>

   <!-- Team -->
    <q-dialog v-model="isOpenTeamDialog">
			<div class="modal_team">
		    <a class="modal_close_btn" @click="toggleTeamDialog(false);">close</a>
		    <h5>TEAM</h5>
		    <div class="contain">
          <ul class="member">
            <li class="name">JAY<span>“블캐는 아시아를 이끄는 포커미디어가 될 거예요.”</span></li>
            <li class="contact"><b>Founder/CEO</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37100/tips_ico_insta.png">@jaay.bak</li>
            <li class="desc">수년 전 부터 한국에도 포커 미디어가 있다면 좋겠다고 생각하곤 했었죠. 한국에서는 약간 음지의 영역이었지만 이미 미국,유럽에서는 성행하고 있었으니까요. 코로나 이후 한국 시장이 급격히 성장하고 있고 아시아시장 또한 계속 커지고 있습니다. 그 중심에 블러프앤캐치가 계속 성장하고 있고, 아시아-태평양 시장을 이끄는 포커미디어를 지향하고 있습니다. 최고의 멤버들이 함께 해주고 있어서 머지않아 이룰 수 있을 것 같네요.😉</li>
          </ul>
          <ul class="member">
            <li class="name">JUN<span>“포커씬의 모두와 소통하고 싶습니다. 어떤 비즈니스 미팅도 환영입니다!”</span></li>
            <li class="contact"><b>Contents Marketer/Business Strategy</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36619/tips_ico_tg.png">@BC_Jun</li>
            <li class="desc">비즈니스 제휴 담당으로 각 브랜드사와 주요 커뮤니테이션을 담당하고 있습니다. 또한 포커 전문 콘텐츠를 작성하고 주요 토너먼트 현장을 리포팅하는 콘텐츠 마케터로 역할도 하고있어요. 주요 브랜드사 담당자들이 보통 외국인이거나 해외거주하는 경우가 많아서 영문 메일이나 Zoom미팅도 자주 가지고 있습니다. 현장취재 기간에는 한 달에 절반 이상을 해외에서 보내는 경우도 많아요. 포커와 포커 플레이어의 삶에 푹 빠져 지내던 시절이 있었는데 마침 블캐를 만나게 되어서 초기 멤버로 함께하게 되었습니다. 아마 대한민국에서 이 일을 하는 사람은 제가 유일 할 걸요?</li>
          </ul>
          <ul class="member">
            <li class="name">LOOPY<span>“현장에서 만나면 인사해요~”</span></li>
            <li class="contact"><b>Contents Marketer</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36619/tips_ico_tg.png">@loopy_kim</li>
            <li class="desc">다른 브랜드의 에디터로 활동하고 있던 와중 대표님의 제안으로 블러프앤캐치에 입사하게 되었습니다. 글은 물론 현장 취재로 전공을 살릴 수 있다는 점과 포커라는 새로운 영역을 탐구한다는 것, 이 2가지가 매력적으로 다가왔어요. 결정적으로 브랜드 오픈 1년 만에 비약적인 발전을 이루어낸 '블러프앤캐치'와 함께 성장하고 싶은 마음이 가장 컸습니다. 팀 내 막내지만 어리숙하지 않은 업무 능력으로 포커 트렌드를 파악하고 있습니다. 아티클 작성, 글로벌 토너먼트 현장 취재, SNS 채널 운영 등을 담당하고 있어요!😎 현장에서 만났을 때 반갑게 인사해요~ 아참, 닉네임 LOOPY는 '고무고무 원피스'가 아닌 '잔망 루피'입니다!</li>
          </ul>
          <ul class="member">
            <li class="name">LIME<span>“한 사람이라도 더 블캐를 알게 하는게 목표예요.”</span></li>
            <li class="contact"><b>Marketer/Operator</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37099/tips_ico_mail.png">lime@bluffcatch.com</li>
            <li class="desc">데이터 및 광고를 포함한 3개 언어의 각 사이트 전반의 관리 및 운영을 담당합니다. 에디터들이 생산해준 콘텐츠를 적절하게 노출하고, 이를 뒷받침할 광고제휴나 데이터도 함께 관리하고 있습니다. 블러프앤캐치라는 미디어 서비스가 이용자들에게 잘 전달되도록 하는 모든 역할을 하고 있다고 볼 수 있겠네요. 새로운 취미로 포커의 매력에 빠지면서 자연스럽게 블캐를 만나 합류하게 되었습니다. 개인적으로는 업무능력과 더불어 타고난(?) 플레이 실력을 인정받아 비공식 앰배서더 겸 멤버로 합류했다고 믿고 있어요. 맞을껄요?🤭</li>
          </ul>
          <ul class="member">
            <li class="name">MANNY</li>
            <li class="contact"><b>Co-Founder/Instagram Manager</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37100/tips_ico_insta.png">@bluffandcatch</li>
            <!--<li class="desc">블러프앤캐치 공식 인스타그램 담당자이자 히든 디렉터</li>-->
          </ul>
        </div>
		  </div>
		</q-dialog>

    <!-- Cookie policy -->
		<q-dialog v-model="isOpenFooter3Dialog">
			<div class="share_pop info_pop">
				<a class="modal_close_btn" @click="toggleFooter3Dialog(false);">close</a>
        <h3>Cookie Notice<br><span>(Bluff&amp;Catch's Use of Cookies)</span></h3>
				<div class="contain">
          <p>Bluff&amp;Catch's website and online services may use "cookies". Cookies allow you to add items to your shopping cart, personalize your experience on the Bluff&amp;Catch website, and let Bluff&amp;Catch know which pages you have visited on our website so that we can measure the effectiveness of our advertising and web searches. This allows Bluff&amp;Catch to measure the efficiency of advertising and web searches. This helps Bluff&amp;Catch to improve its communication, content and products.</p>
          <p>If you do not agree to the use of cookies in your web browser, please select "I do not agree to the use of cookies" from the privacy menu in your browser settings. The method of setting cookies may vary depending on the browser you are using, so please check with each browser for instructions on how to set cookies.</p>
          <p>Cookies are used across all Bluff&amp;Catch sites, so if you do not agree to the use of cookies, you may not be able to use certain parts of the site.</p>
          <p>The cookies used on the Bluff&amp;Catch website are based on the International Chamber of Commerce (ICC) UK Cookie Guide classification. Bluff&amp;Catch uses the following types of cookies for the Bluff&amp;Catch website and other online services</p>
          <h6>1. Mandatory cookies</h6>
          <p>Mandatory cookies are cookies that are essential for you to be able to search the Bluff&amp;Catch website and use the features offered on our site. If you do not agree to the use of cookies, you will not be able to add products to your cart on our site or use services such as e-billing.</p>
          <h6>2. Performance cookies</h6>
          <p>Performance cookies primarily collect information about how you use our site, such as information about the pages you visit. The data collected is used to improve the performance of the Site and to promote the optimization of your use of the Site. Data on access to this site, use of services, shopping history, etc. is shared by our website and our group companies for the purpose of providing services to our customers. Please note that these cookies do not identify any specific individuals. All information collected by performance cookies is aggregated and thus anonymous.</p>
          <h6>3. Functional analysis cookies</h6>
          <p>Functional analysis cookies allow the Bluff&amp;Catch website to remember the choices you make within the site during your visit. For example, geographic locations can be stored in cookies to localize the website to the user's region. It can also remember settings such as text size, fonts, and other customizable site elements. They can also analyze product browsing history and video playback, and use the data to present you with products and videos that match your preferences. These cookies do not identify individual users and it is not possible to track your browsing behavior on other non-Bluff&amp;Catch websites.</p>
				</div>
			</div>
		</q-dialog>
    <!-- Cookie policy //-->

  </footer>
  <!-- //footer_area -->

</template>

<script>
  import { QDialog } from 'quasar'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  export default {
    name: "Footer",
    components: {
      QDialog
    },
    data () {
      return {
        time: '',
      }
    },
    mounted () {
			this.getTime()
    },
    computed: {
      ...CommonComputed,
      isOpenFooter1Dialog: {
        get () {
          return this.$store.getters.isOpenFooter1Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter1Dialog', flag)
        }
      },
      isOpenFooter2Dialog: {
        get () {
          return this.$store.getters.isOpenFooter2Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter2Dialog', flag)
        }
      },
      isOpenFooter3Dialog: {
        get () {
          return this.$store.getters.isOpenFooter3Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter3Dialog', flag)
        }
      },
      isOpenFaqDialog: {
        get () {
          return this.$store.getters.isOpenFaqDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFaqDialog', flag)
        }
      },
      isOpenTeamDialog: {
        get () {
          return this.$store.getters.isOpenTeamDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenTeamDialog', flag)
        }
      },
      currentYear () {
        return new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' })
        ).getFullYear()
      }
    },
    methods: {
      ...CommonMethods,
      toggleFooter1Dialog (flag) {
        this.$store.dispatch('setOpenFooter1Dialog', flag)
      },
      toggleFooter2Dialog (flag) {
        this.$store.dispatch('setOpenFooter2Dialog', flag)
      },
      toggleFooter3Dialog (flag) {
        this.$store.dispatch('setOpenFooter3Dialog', flag)
      },
      toggleFaqDialog (flag) {
        this.$store.dispatch('setOpenFaqDialog', flag)
      },
      toggleTeamDialog (flag) {
        this.$store.dispatch('setOpenTeamDialog', flag)
      },
      getTime() {
				setInterval( () => {
          var today = new Date();
          var year = today.getFullYear();
          var month = ((today.getMonth() + 1));
          var day = (today.getDate());
//          var month = ('0' + (today.getMonth() + 1)).slice(-2);
//          var day = ('0' + today.getDate()).slice(-2);
          this.time = year + '년 ' + month + '월 ' + day + '일';
				}, 1000);
			},
    }
  }
</script>

<style scoped>
  .footerArea {
    min-width: 1270px;
    text-align: center;
    margin: 0 auto;
  }
  .footerArea .inner {
    width: 1220px;
    border-top: 2px solid #000;
    padding: 50px 0;
  }
  .footerArea .inner ul {
    display: inline-block;
    width: 33.333%;
    padding: 0 38px;
  }
  .footerArea .inner ul:last-child {
    border-right: 0;
  }
  .footerArea .inner ul.company {
    border-left: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
  }
  .footerArea .inner ul li:last-child {
    margin-bottom: 0;
  }
  .footerArea .inner li {
    font-size: 15px;
    font-weight: 600;
    color: #777;
    letter-spacing: -0.01em;
    line-height: 1.8em;
    text-align: left;
    margin-bottom: 25px;
  }
  .footerArea .inner li i {
    color: #bbb;
  }
  .footerArea .inner li p {
    font-size: 16px;
    font-weight: 800;
    color: #000;
    margin-bottom: 5px;
  }
  .footerArea .inner li a {
    color: #008c03;
  }
  .footerArea .inner li a:hover {
    text-decoration: underline;
  }
  .footerArea .inner .bi p:after {
    content: "™";
    position: absolute;
  }
  .footerArea .inner .bi li {
    text-align: center;
  }
  .footerArea .inner .bi .img {
    margin-bottom: 15px;
  }
  .footerArea .lang {

  }
  .footerArea .lang a {
    display: inline-block;
    margin: 5px;
    position: relative;
    width: 45px;
    height: 60px;
  }
  .footerArea .lang a:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.25);
    border-radius: 0.3em;
    z-index: 1;
  }
  .footerArea .lang img {
    max-width: 100%;
    max-height: 100%;
  }
  .footerArea .lang .current:after {
    border: 1px solid rgba(0,0,0,1.0);
  }
  .footerArea .lang .current img {
    opacity: 1.0;
  }
  .footerArea .lang .empty {
    position: relative;
    display: inline-block;
    margin: 5px;
    width: 45px;
    height: 60px;
    background-image: url(/statics/img/bi.png);
    background-color: #fff;
    background-size: 60%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border-radius: 0.3em;
    isolation: isolate;
  }
  .footerArea .lang .empty:after {
    content: "";
    position: absolute;
    background: #ddd;
    inset: 0;
    opacity: 0.75;
    border-radius: 0.3em;
    border: 1px dashed rgba(0,0,0,0.25);
  }
  .footerArea .inner .company li.about {
    margin-bottom: 10px;
  }
  .footerArea .inner .company li a {
    display: inline-block;
    color: #777;
    font-weight: 800;
    cursor: pointer;
  }
  .footerArea .inner .company li a:hover {
    color: #008c03;
  }
  .footerArea .inner .company li a.channel {
    display: inline-block;
    padding: 10px 10px 0 10px;
  }
  .footerArea .inner .company li a.channel:nth-child(2) {
    padding-left: 0;
  }
  .footerArea .inner .company li a.channel img {
    height: 32px;
  }

  .share_pop {
    position: relative;
    background: #fff;
  }
  .share_pop .close_btn {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    font-size: 0;
    text-indent: -9999px;
    background: url(/statics/img/close_01.png);
		background-size: 100%;
		z-index: 1;
  }
	.share_pop ul li {
		position: relative;
		font-size: 12px;
		text-align: center;
		display: inline-block;
		width: 25%;
		margin-bottom: 20px;
		cursor: pointer;
	}
  .q-dialog__inner .info_pop {
    width: 50vw;
    height: 80vh;
    max-width: unset;
    max-height: unset;
		padding: 80px 0 0;
    overflow-y: hidden;
	}
	.info_pop h3 {
    position: absolute;
    top: 18px;
		width: 100%;
    font-size: 18px;
		font-weight: 800;
		text-align: center;
    line-height: 1.20em;
	}
  .info_pop h3 span {
		font-size: 0.8em;
    font-weight: 600;
	}
	.info_pop .contain {
		width: 100%;
    height: 100%;
    padding: 0 25px 25px;
    overflow-y: scroll;
    font-size: 15px;
    font-weight: 500;
    color: #777;
    line-height: 1.6em;
    word-break: normal;
	}
	.info_pop .contain h6 {
		font-size: 16px;
		font-weight: 800;
    color: #000;
		letter-spacing: -0.01em;
		margin: 15px 0 10px;
		line-height: 1.6em;
	}
	.info_pop .contain p {
		margin: 4px 0 10px;
	}
	.info_pop .contain ol li {
		list-style: decimal;
    margin-left: 18px;
    margin-bottom: 6px;
	}
	.info_pop .contain ol li:last-child {
    margin-bottom: 18px;
	}
	.info_pop .contain ul li {
		list-style-type: "-";
    margin-left: 18px;
    margin-bottom: 6px;
	}
	.info_pop .contain ul li:last-child {
    margin-bottom: 18px;
	}
  .info_pop.contents {
    width: auto !important;
		height: auto !important;
	}
  .info_pop.contents h3 {
    width: 100% !important;
	}
  .info_pop.contents .contain {
    overflow: hidden;
    padding: 0 20px 20px;
	}
  .info_pop.teen {
    height: auto;
	}
  .layerBackdrop > div {
    position: relative;
    padding: 15px;
  }
  /deep/ .layerBackdrop a > img {
    max-width: 320px !important;
  }
	/* on wallpaper */
	.wallpaper .footerArea {
   background: #fff;
  }

  /* FAQ Modal */
  .modal_faq {
    position: relative;
    max-width: unset;
    width: 680px;
    height: auto;
    background: #fff;
    border-radius: 5px;
    padding-top: 80px;
  }
  .modal_faq h5 {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.03em;
    position: absolute;
    top: 0;
    left: 0;
  }
  .modal_faq .contain {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0 30px 30px;
  }
  .modal_faq ul.qna li {
    font-size: 15px;
    font-weight: 500;
    color: #666;
    line-height: 1.6em;
    padding-left: 25px;
    position: relative;
  }
  .modal_faq ul.qna li.ans:last-child {
    margin-bottom: 10px;
  }
  .modal_faq ul.qna li.que {
    font-size: 16px;
    font-weight: 800;
    color: #222;
    margin-bottom: 8px;
  }
  .modal_faq ul.qna li.que:before {
    content: "Q.";
    position: absolute;
    font-weight: 900;
    color: #000;
    left: 0;
  }
  .modal_faq ul.qna li.ans {
    border-radius: 12px;
    margin-bottom: 22px;
  }
  .modal_faq ul.qna li.ans:before {
    content: "A.";
    position: absolute;
    font-size: 16px;
    font-weight: 900;
    color: #00b30a;
    left: 0;
  }
  .modal_close_btn {
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
		width: 40px;
		height: 40px;
		font-size: 0;
		text-indent: -9999px;
		background: url(/statics/img/close_01.png) no-repeat;
		background-size: 50%;
    background-position: center;
		z-index: 1;
	}
	.modal_close_btn:hover:before {
		content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
    width: 40px;
    height: 40px;
    background: rgba(0,0,0,0.05);
    border-radius: 100%;
	}

  /* Team Modal */
  .modal_team {
    position: relative;
    max-width: unset;
    width: 680px;
    height: calc(100% - 80px);
    background: #fff;
    border-radius: 5px;
    padding-top: 80px;
  }
  .modal_team h5 {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.03em;
    position: absolute;
    top: 0;
    left: 0;
  }
  .modal_team .contain {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 0 30px 30px;
  }
  .modal_team ul {
    background: #f9f9f9;
    padding: 25px;
    border-radius: 6px;
    margin-bottom: 15px;
  }
  .modal_team ul:last-child {
    margin-bottom: 0;
  }
  .modal_team ul:last-child .contact {
    margin-bottom: 0;
  }
  .modal_team ul li {
    font-size: 15px;
    font-weight: 500;
    color: #666;
    line-height: 1.0em;
    position: relative;
  }
  .modal_team ul li.name {
    font-size: 18px;
    font-weight: 900;
    color: #222;
    letter-spacing: -0.03em;
    line-height: 1.0em;
  }
  .modal_team ul li.name span {
    font-size: 16px;
    font-weight: 500;
    color: #888;
    margin-left: 10px;
  }
  .modal_team ul li.contact {
    font-size: 14px;
    color: #222;
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 16px;
  }
  .modal_team ul li.contact h6 {
    font-size: 18px;
    font-weight: 900;
    color: #222;
    letter-spacing: -0.03em;
    line-height: 1.0em;
  }
  .modal_team ul li.contact b {
    font-weight: 700;
  }
  .modal_team ul li.contact img {
    width: 16px;
    margin: 0 4px 0 8px;
  }
  .modal_team ul li.desc {
    line-height: 1.6em;
  }
</style>
